export default {
  title: 'Ricevi volantini mensili automatici',
  status: {
    enabled: 'Abilitato',
    disabled: 'Disabilitato',
  },
  opt_out: {
    on_hint: 'Il tuo piano FoodAmigos include 500 volantini gratuiti al mese. Disattiva per smettere di riceverli.',
    off_hint: 'I volantini automatici sono in pausa. Attiva per riprendere dal ciclo del mese prossimo.',
    confirm_off: {
      title: 'Disattivare i volantini automatici?',
      body: 'Disattivando questa opzione, {{location}} non riceverà volantini automatici dal prossimo ciclo mensile. Gli ordini esistenti non sono interessati.',
      confirm: 'Disattiva',
      cancel: 'Mantieni attivo',
    },
  },
  approved_design: {
    label: 'Design approvato per i volantini mensili',
    auto_option: 'Automatico (ultimo ordinato)',
    flyer_slot: 'Volantino {{slot}}',
    custom: 'Personalizzato',
    untitled: 'Senza titolo',
    invalid_warning:
      "Il design salvato non è più disponibile. Verrà usato l'ultimo volantino ordinato finché non ne selezioni uno nuovo.",
  },
  toasts: {
    failed_to_load: 'Impossibile caricare le impostazioni volantini automatici',
    failed_to_save: 'Impossibile salvare le modifiche',
    saved: 'Modifiche salvate',
  },
};
